/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IncidentProcessingCriteriaTOV2 } from './incidentProcessingCriteriaTOV2';
import { AutomatedOrderCreationActionTOV2 } from './automatedOrderCreationActionTOV2';


/**
 * Daten zur automatischen Mitarbeiterzuordnung und Auftragsanlage
 */
export interface AutomatedIncidentPostProcessingRuleTOV2 { 
    /**
     * The rule id
     */
    ruleUuid?: string;
    criteria: IncidentProcessingCriteriaTOV2;
    /**
     * Der Mitarbeiter welcher der Störung für das Kriterium zugeordnet werden soll
     */
    assignee?: string;
    /**
     * Aktivierungszustand der Regel, aktiv/inaktiv
     */
    active?: boolean;
    /**
     * Time in days for which after the first incident matching the criteria no new Order should be created.
     */
    suppressionPeriod?: number;
    action?: AutomatedOrderCreationActionTOV2;
}

